/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Delete_DocumentInputs */

const en_read_along_delete_document = /** @type {(inputs: Read_Along_Delete_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete document`)
};

const es_read_along_delete_document = /** @type {(inputs: Read_Along_Delete_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar documento`)
};

/**
* | output |
* | --- |
* | "Delete document" |
*
* @param {Read_Along_Delete_DocumentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_delete_document = /** @type {((inputs?: Read_Along_Delete_DocumentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Delete_DocumentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_delete_document(inputs)
	return en_read_along_delete_document(inputs)
});